// Generated by CoffeeScript 1.12.7
(function () {
  var PayNowStep,
    addQuoteDetails,
    indexOf =
      [].indexOf ||
      function (item) {
        for (var i = 0, l = this.length; i < l; i++) {
          if (i in this && this[i] === item) return i;
        }
        return -1;
      };

  addQuoteDetails = require("../Utils/AddQuoteDetails")["default"];

  module.exports = PayNowStep = (function () {
    function PayNowStep(di, createUi, make, closeCurrent, closeAll, Tooltip, $timeout, $q, accepters) {
      var form, isPreview, paymentAcceptData, setErrorMsg;
      setErrorMsg = function (message, selector) {
        var position, tooltip;
        if (selector != null) {
          position = "bottom";
        } else {
          position = "top";
        }
        if (selector == null) {
          selector = ".pay-now-step .button-primary";
        }
        tooltip = make(Tooltip, {
          targetSelector: selector,
          options: {
            container: ".pay-now-step",
            position: position,
            stringContent: message,
            spacing: 5,
            customTheme: "error-theme",
          },
        });
        tooltip.show();
        return tooltip;
      };
      paymentAcceptData = {};
      form = make(require("./PayNowForm").default, {
        isGroupAccept: true,
        setErrorMsg: setErrorMsg,
      });
      isPreview = di.has("isPreviewMode") ? di.get("isPreviewMode") : false;
      this.ui = createUi(require("./PayNowStep.html"), {
        viewState: "open",
        setViewState: (function (_this) {
          return function (state) {
            var validStates;
            validStates = ["open", "sending", "complete"];
            if (indexOf.call(validStates, state) >= 0) {
              _this.ui.viewState = state;
            }
            return $q.resolve();
          };
        })(this),
        canGoBack: (function (_this) {
          return function () {
            return _this.ui.viewState === "open";
          };
        })(this),
        goBack: closeCurrent,
        close: closeAll,
        payNowForm: form.ui,
        finish: (function (_this) {
          return function () {
            var isValid;
            isValid = form.validate();
            if (!isValid) {
              return;
            }
            _this.ui.setViewState("sending");
            if (isPreview) {
              return _this.mockAdding();
            } else {
              return _this.addPaymentDetails();
            }
          };
        })(this),
      });
      this.addPaymentDetails = (function (_this) {
        return function () {
          return form
            .finalise(paymentAcceptData)
            .then(function () {
              accepters.paymentAdded = true;
              accepters.paymentAddedAt = Date.now();
              return _this.ui.setViewState("complete");
            })
            ["catch"](function (err) {
              _this.ui.setViewState("open");
              return $timeout(function () {
                var errorTooltip, ref;
                errorTooltip =
                  ((ref = err.data) != null ? ref.message : void 0) != null
                    ? setErrorMsg(err.data.message)
                    : err.message != null
                    ? setErrorMsg(err.message)
                    : setErrorMsg(err);
                return $timeout(function () {
                  return errorTooltip.hide();
                }, 3000);
              });
            });
        };
      })(this);
      this.mockAdding = (function (_this) {
        return function () {
          return $timeout(function () {
            return _this.ui.setViewState("complete");
          }, 2000);
        };
      })(this);
    }

    return PayNowStep;
  })();
}.call(this));
